export class LogoModel {
  id: number;
  title: string;
  imageUrl: string;
  isActive: boolean;
  file: File;
  link: string;
  position: number;
}
